import LZString from 'lz-string';

const CACHE_KEY = 'recently_viewed_products';
const MAX_ITEMS = 10;

type Entry = {
  productId: string;
  html: string;
};

const getStorage = (): Storage | null => {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

const read = (): Entry[] => {
  const storage = getStorage();
  if (!storage) return [];

  try {
    const compressed = storage.getItem(CACHE_KEY);
    if (!compressed) return [];

    const json = LZString.decompressFromUTF16(compressed);
    if (!json) return [];

    return JSON.parse(json) as Entry[];
  } catch {
    return [];
  }
};

const write = (entries: Entry[]): void => {
  const storage = getStorage();
  if (!storage) return;

  try {
    storage.setItem(CACHE_KEY, LZString.compressToUTF16(JSON.stringify(entries)));
  } catch {
    storage.removeItem(CACHE_KEY);
  }
};

export const saveRecentlyViewed = (productId: string, html: string): void => {
  const entries = read().filter((e) => e.productId !== productId);
  entries.unshift({ productId, html });
  write(entries.slice(0, MAX_ITEMS));
};

export const getRecentlyViewed = (excludeProductId?: string, limit?: number): Entry[] => {
  let entries = read();

  if (excludeProductId) {
    entries = entries.filter((e) => e.productId !== excludeProductId);
  }

  return limit != null ? entries.slice(0, limit) : entries;
};
